<template>
  <div class="xlog-decoder">
    <el-card class="decoder-card">
      <div slot="header" class="clearfix">
        <h2>售后 Xlog 日志解码工具</h2>
        <p class="desc">一键将售后上传的 xlog 压缩包解码为明文的 txt/log 文件并下载。</p>
      </div>

      <el-form label-position="top">
        <el-form-item label="方式一：输入 OSS 链接（直接获取）">
          <div style="display: flex; gap: 12px;">
            <el-input 
              v-model="ossUrl" 
              placeholder="请输入日志 ZIP 文件的 OSS 链接" 
              clearable>
            </el-input>
            <el-button 
              type="primary" 
              icon="el-icon-download" 
              @click="processUrl" 
              :loading="loading"
              :disabled="!ossUrl">处理并下载</el-button>
          </div>
        </el-form-item>

        <el-divider>或者</el-divider>

        <el-form-item label="方式二：选择本地 ZIP 文件（解决跨域问题）">
          <el-upload
            class="upload-demo"
            action=""
            drag
            :auto-upload="false"
            :on-change="onFileChange"
            :show-file-list="false"
            accept=".zip">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击选择 ZIP 文件</em></div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div class="status-box" v-if="loading || currentStep > 0">
        <el-steps :active="currentStep" finish-status="success">
          <el-step title="提交请求" description="发送至后端处理"></el-step>
          <el-step title="处理并下载" description="后端自动解码并保存"></el-step>
          <el-step title="完成" description="操作结束"></el-step>
        </el-steps>
      </div>
      <div v-if="successMsg" class="success-msg">
        <el-alert :title="successMsg" type="success" show-icon :closable="false"></el-alert>
      </div>
      <div v-if="errorMsg" class="error-msg">
        <el-alert :title="errorMsg" type="error" show-icon :closable="false"></el-alert>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';
import { saveAs } from 'file-saver';

export default {
  name: 'XlogDecoder',
  data() {
    return {
      ossUrl: '',
      loading: false,
      currentStep: 0,
      successMsg: '',
      errorMsg: ''
    };
  },
  methods: {
    async processUrl() {
      if (!this.ossUrl) {
        this.$message.warning('请输入 OSS 链接');
        return;
      }
      this.resetStatus();
      this.loading = true;
      try {
        this.currentStep = 1;
        const response = await axios.post('/api/blog/xlog/decode/', {
          ossUrl: this.ossUrl
        }, { 
          responseType: 'blob' 
        });
        
        this.currentStep = 2;
        saveAs(response.data, 'decoded_logs.zip');
        
        this.currentStep = 3;
        this.successMsg = '处理成功！已触发下载：decoded_logs.zip';
      } catch (err) {
        console.error(err);
        let msg = '处理失败，请检查网络或链接是否正确。';
        if (err.response && err.response.data instanceof Blob) {
            try {
                const text = await err.response.data.text();
                const json = JSON.parse(text);
                if (json.error) msg = json.error;
            } catch (e) {}
        }
        this.errorMsg = msg;
      } finally {
        this.loading = false;
      }
    },
    async onFileChange(file) {
      if (!file || !file.raw) return;
      this.resetStatus();
      this.loading = true;
      try {
        this.currentStep = 1;
        const formData = new FormData();
        formData.append('file', file.raw);

        const response = await axios.post('/api/blog/xlog/decode/', formData, { 
          responseType: 'blob',
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        this.currentStep = 2;
        const baseName = file.name.replace(/\.zip$/i, '');
        saveAs(response.data, `${baseName}_decoded.zip`);
        
        this.currentStep = 3;
        this.successMsg = `处理成功！已触发下载：${baseName}_decoded.zip`;
      } catch (err) {
        console.error(err);
        let msg = `处理本地文件时发生错误`;
        if (err.response && err.response.data instanceof Blob) {
            try {
                const text = await err.response.data.text();
                const json = JSON.parse(text);
                if (json.error) msg = json.error;
            } catch (e) {}
        }
        this.errorMsg = msg;
      } finally {
        this.loading = false;
      }
    },
    resetStatus() {
      this.successMsg = '';
      this.errorMsg = '';
      this.currentStep = 0;
    }
  }
};
</script>

<style scoped>
.xlog-decoder {
  display: flex;
  justify-content: center;
  padding: 40px;
  background: #f0f2f5;
  min-height: calc(100vh - 80px); /* Adjust based on your header if any */
}
.decoder-card {
  width: 100%;
  max-width: 700px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}
.clearfix h2 {
  margin: 0;
  font-weight: 600;
  color: #333;
}
.desc {
  color: #666;
  font-size: 14px;
  margin-top: 8px;
  margin-bottom: 0;
}
.status-box {
  margin-top: 30px;
  padding: 20px;
  background: #fafafa;
  border-radius: 8px;
}
.success-msg, .error-msg {
  margin-top: 20px;
}
.upload-demo {
  width: 100%;
}
.upload-demo ::v-deep .el-upload {
  width: 100%;
}
.upload-demo ::v-deep .el-upload-dragger {
  width: 100%;
}
</style>
